module.exports = __webpack_public_path__ + "static/img/Dungeon & Fighter Mobile.704838cd.png";